import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import callingStirShaken from 'shared/assets/images/compliance/callingStirShaken.png'
import { InputCheckbox, Typography } from 'shared/ui'
import {
  LINK_COMPLIANCE_CALLING_TELEPHONY_POLICY_LINK,
  LINK_COMPLIANCE_TELECOM_TRACEBACK_GROUP,
} from 'shared/constants/links'
import { getCDNAssetURL } from 'shared/lib'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { LearnMoreLink } from 'pages/settings/ui/LearnMoreLink/LearnMoreLink'
import { useCallingStepsContext } from 'pages/settings/pages/compliance/pages/calling/context/callingStepsContext'
import styles from './styles.module.scss'

export const EnableStirShaken = observer(() => {
  const {
    stepsStore: { stepLoading, setTotalSteps },
    stirShakenStore: { isTermsAndPrivacyChecked, toggleIsTermsAndPrivacyChecked, submitStirShaken },
  } = useCallingStepsContext()

  useEffect(() => {
    setTotalSteps(1)
  }, [])

  return (
    <div>
      <div className={styles.descriptionWrap}>
        <PageDescription>Increase answer rates by showing “Caller Verified”</PageDescription>
      </div>

      <img
        src={getCDNAssetURL(callingStirShaken)}
        alt={'callingStirShaken_image'}
        className={styles.image}
      />

      <InputCheckbox
        className={styles.declaration}
        checked={isTermsAndPrivacyChecked}
        onChecked={() => toggleIsTermsAndPrivacyChecked(!isTermsAndPrivacyChecked)}
        color='var(--content-primary-tertiary)'
        label={
          <>
            <Typography
              ariaLabel='declaration'
              variant='body-md-regular'
              tag='div'
              className={styles.declarationText}
            >
              I certify that the associated Business Profile is the originator of the phone calls
              and certify that I will participate in traceback efforts, including those initiated by
              the
              {
                <LearnMoreLink href={LINK_COMPLIANCE_CALLING_TELEPHONY_POLICY_LINK}>
                  Secure Telephony Identity Policy Administrator (STI-PA)
                </LearnMoreLink>
              }
              &nbsp;and the
              <LearnMoreLink href={LINK_COMPLIANCE_TELECOM_TRACEBACK_GROUP}>
                US Telecom Traceback Group.
              </LearnMoreLink>
            </Typography>
          </>
        }
      />

      <NextButton
        text='Submit for review'
        loading={stepLoading}
        disabled={!isTermsAndPrivacyChecked}
        onClick={submitStirShaken}
      />
    </div>
  )
})
